import { render } from "./DickThree.vue?vue&type=template&id=3cac6295"
import script from "./DickThree.vue?vue&type=script&lang=js"
export * from "./DickThree.vue?vue&type=script&lang=js"

import "./DickThree.vue?vue&type=style&index=0&id=3cac6295&lang=css"
script.render = render

export default script